import { createSelector } from '@ngrx/store';
import { MyZoneState, getMyZoneState } from '../my-zone';
import * as fromScenarios from './scenarios.reducer';

export const getScenariosState = createSelector(getMyZoneState, (state: MyZoneState) => state.scenarios);
export const getScenarioEntities = createSelector(getScenariosState, fromScenarios.getEntities);
export const getScenarioIds = createSelector(getScenariosState, fromScenarios.getIds);
export const getAllScenarios = createSelector(getScenariosState, fromScenarios.getAll);
